import React, { useState, useEffect, useMemo } from 'react';
import { PROJECTED_HORIZONS } from '../../../core/constants/financial';
import { loadBanksWithCurrentBalance } from '../../../core/utils/bank';
import {
  loadProjectedMovements,
  computeDailyProjection,
  getInitialBalance,
} from '../../../core/utils/projectedCashFlow';
import ProjectedCashFlowChart from './ProjectedCashFlowChart';
import Skeleton from './Skeleton';

// Painel do dashboard com o gráfico de Fluxo de Caixa Projetado (todos os
// bancos). A versão completa, com filtro por banco e tabela, fica no
// ProjectedCashFlowModal.
const ProjectedCashFlowPanel = ({ companyId, refreshKey = 0 }) => {
  const [horizonDays, setHorizonDays] = useState(15);
  const [banks, setBanks] = useState([]);
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId) return;
    let cancelled = false;
    setLoading(true);
    Promise.all([
      loadBanksWithCurrentBalance(companyId),
      loadProjectedMovements({ companyId, horizonDays }),
    ]).then(([bankList, moves]) => {
      if (cancelled) return;
      setBanks(bankList || []);
      setMovements(moves || []);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [companyId, horizonDays, refreshKey]);

  const initialBalance = useMemo(() => getInitialBalance(banks, ''), [banks]);
  const projection = useMemo(
    () => computeDailyProjection(movements, initialBalance, horizonDays),
    [movements, initialBalance, horizonDays]
  );

  return (
    <div className="fd-panel">
      <div className="fd-panel-header">
        <h3 className="fd-panel-title">Fluxo de Caixa Projetado</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {PROJECTED_HORIZONS.map((h) => (
            <button
              key={h.days}
              type="button"
              className={`fd-period-btn ${horizonDays === h.days ? 'fd-period-btn--active' : ''}`}
              onClick={() => setHorizonDays(h.days)}
            >
              {h.label}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="fd-chart-skeleton">
          <Skeleton width="100%" height="100%" />
        </div>
      ) : (
        <ProjectedCashFlowChart data={projection} height="100%" />
      )}
    </div>
  );
};

export default ProjectedCashFlowPanel;
